import React from "react";
import { FaTicketAlt } from "react-icons/fa";

const UserTicketsCard = ({ tickets }) => {
  return (
    <div className="viewing-organiser-card viewing-organiser-full-width-card">
      <div className="viewing-organiser-card__header viewing-organiser-card__header--secondary">
        <FaTicketAlt className="viewing-organiser-card__icon" />
        <h2 className="viewing-organiser-card__title">Purchased Tickets</h2>
      </div>
      <div className="viewing-organiser-card__body">
        {tickets && tickets.length > 0 ? (
          <table className="viewing-organiser-events-table">
            <thead>
              <tr>
                <th>Event Name</th>
                <th>Purchase Date</th>
                <th>Ticket Type</th>
              </tr>
            </thead>
            <tbody>
              {tickets.map((ticket, index) => (
                <tr key={`ticket-${ticket.ticket_id || index}`}>
                  <td className="viewing-organiser-events-table__name">
                    {ticket.event_name || "Unknown Event"}
                  </td>
                  <td className="viewing-organiser-events-table__date">
                    {ticket.purchase_date 
                      ? new Date(ticket.purchase_date).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })
                      : "N/A"
                    }
                  </td>
                  <td>{ticket.package_name || ticket.ticket_type || "Standard"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="viewing-organiser-no-tickets">
            <FaTicketAlt className="viewing-organiser-no-tickets__icon" />
            <p className="viewing-organiser-no-tickets__text">
              No tickets purchased yet
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserTicketsCard;
